<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <SharedAdminHeader
      :title="activeTab === AdminKycTab.kyc ? 'KYC' : 'KYC / Balance'"
      :is-loading="isLoading"
      :tabs="displayedTabs"
      v-model:id="adminKycHeader.id"
      v-model:type="adminKycHeader.type"
      @search="handleSearch"
      @tab-change="handleTab"
    />

    <div v-if="activeTab === AdminKycTab.kyc">
      <AdminKycWrapper
        v-if="!!isWrapperShow"
        :email="adminUserAppResponse.user.email"
        :id="adminUserAppResponse.index"
        :type="adminUserAppResponse.type"
      >
        <component
          :is="displayedComponent"
          :id="adminUserAppResponse.user_id"
          v-model:component="component"
        />
      </AdminKycWrapper>

      <component
        v-if="isFooterShow"
        :is="displayedFooterComponent"
        :id="adminUserAppResponse.user_id"
        v-model:component="component"
        v-model:is-loading="isLoading"
        v-model:status="adminUserAppResponse.status"
        v-model:type="adminUserAppResponse.type"
      />
    </div>

    <div v-else-if="activeTab === AdminKycTab.balance">
      <AdminKycWrapper
        v-if="displayedUser"
        :email="displayedUser.email"
        :id="adminKycHeader.id"
        :type="displayedUser.kyc_status ? 'kyc' : 'kyb'"
      >
        <AdminKycBalance :id="adminKycHeader.id" />
      </AdminKycWrapper>
    </div>
  </div>
</template>
